<template lang="pug">
  v-layout(row wrap class="mediumLarge")
    v-flex(md6 lg6)
      .box-global-info
        h2
          | información de mi seguro
        ul
          ol
            p
              img(:src="icons.numeroPoliza" style="width:16px;margin-left:3px;margin-right:10px;" alt="numero-poliza")
              | N° de póliza
            p.omnesMedium.poliza-download
              | {{ annuity.numeroPoliza }}
              img(:src="icons.download" @click="downloadPDFs('polizas', null)" alt="download")
          ol
            p
              img(:src="icons.calendar" alt="calendar")
              | Fecha de vigencia
            p.omnesMedium {{ annuity.fechaVigencia }} - {{ annuity.fechaFinVigencia }}
          //- ol
            p
              img(:src="icons.sumaAsegurada" alt="shield")
              | Renta a pagar
              v-menu(v-model='tooltips.showRentaPagar' open-on-hover :close-on-content-click='false' :nudge-top='25' :nudge-right='5' offset-x='')
                template(v-slot:activator='{ on }')
                  img(v-on="on" :src="icons.question" width="20px" alt="question" class="question-mark-icon")
                v-card#popover-info
                  span
                    | Monto total a pagar
            p.omnesMedium {{ currency }}  {{ parseFloat(annuity.netoPago).toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') }}
          ol
            p
              img(:src="icons.frecuenciaPago" alt="calendar")
              | Frecuencia de pago
            p.omnesMedium Mensual
          //- ol
          //-   p
          //-     img(:src="icons.pagadoHasta" alt="check")
          //-     | Monto de devolución
          //-   p.omnesMedium {{ annuity.montoDevolucion.toString().replace(/(\d)(?=(\d{3})+(?!\d))/g, '$1,') }}
      .box-agente.constancia(v-if="downConstjubil")
        h2
          | Constancia de pensionista
          v-menu(v-model='tooltips.showConstancia' open-on-hover :close-on-content-click='false' :nudge-top='29' :nudge-right='5' offset-x='')
            template(v-slot:activator='{ on }')
              img(v-on="on" :src="icons.question" width="20px" alt="question" class="question-mark-icon")
            v-card#popover-info
              span
                | Podrás descargar tu
                br
                | constancia de pensionista
        br
        p
          span Descargar constancia
          v-btn(type='button' @click="downloadPDFs('constancia-jubila', null)")
            img(:src="icons.download" :srcset="icons.download" alt="iconDownload")
      .box-agente.cronograma-rentas(v-if="(annuity.tipoPension != null && tipoPensionRVI.includes(annuity.tipoPension)) || ['IFP', 'RPP'].includes(annuity.codigoProducto)")
        h2
          | Cronograma de pagos
          v-menu(v-model='tooltips.showDescargaCronogramaRenta' open-on-hover :close-on-content-click='false' :nudge-top='29' :nudge-right='5' offset-x='')
            template(v-slot:activator='{ on }')
              img(v-on="on" :src="icons.question" width="20px" alt="question" class="question-mark-icon")
            v-card#popover-info
              span
                | Podrás descargar tu
                br
                | cronograma de pago de tus rentas
        br
        p
          span Descargar cronograma de pagos
          v-btn(v-if="(annuity.tipoPension != null && tipoPensionRVI.includes(annuity.tipoPension))" type='button' @click="downloadPDFs('cronograma-rvi', null)")
            img(:src="icons.download" :srcset="icons.download" alt="iconDownload")
          v-btn(v-else-if="['IFP', 'RPP'].includes(annuity.codigoProducto)" type='button' @click="downloadPDFs('cronograma-rpp', null)")
            img(:src="icons.download" :srcset="icons.download" alt="iconDownload")
      //- .box-beneficiarios
        h2
          | Mi beneficiario (a)
          //- v-menu(v-model='tooltips.showBeneficiarios' open-on-hover :close-on-content-click='false' :nudge-top='22' :nudge-right='5' offset-x='')
            template(v-slot:activator='{ on }')
              img(v-on="on" :src="icons.question" width="20px" alt="question" class="question-mark-icon")
            v-card#popover-info
              span
                | Detallamos el nombre de los
                br
                | beneficiarios y el porcentaje que
                br
                | les corresponde de tu póliza de vida.
        v-layout(row wrap)
          v-flex(md8 lg8 class="name-beneficiario")
            p
              img(:src="icons.shield" alt="mensajeAgente")
              | {{ annuity.asegurado }}
      //- .box-agente
    v-flex(md1 lg1)
    v-flex(md5 lg5)
      .box-estado-cuenta
        h2
          | Boletas
          //- v-menu(v-model='tooltips.showEstadoCuenta' open-on-hover :close-on-content-click='false' :nudge-top='29' :nudge-right='5' offset-x='')
            template(v-slot:activator='{ on }')
              img(v-on="on" :src="icons.question" width="20px" alt="question" class="question-mark-icon")
            v-card#popover-info
              span
                | Encuentra el estado de póliza,
                br
                | monto de cobertura, pagos,
                br
                | fecha de pago.
        v-layout(row wrap)
          v-flex(xs12 sm12 md12 lg12)
            p Fecha:
          v-flex(xs6 sm3 md3 lg3)
            label Desde
            v-dialog(ref='dialogStartEECC' v-model='boletas.modalStartDialog', :return-value.sync="boletas.startDate" persistent='' lazy='' full-width='' width='290px')
              v-text-field(slot='activator' hide-details v-model="boletas.textFieldStartDate" outline readonly='')
              v-date-picker(v-model="boletas.startDate" locale="es-005" :max="boletas.endDate" type='month' scrollable='')
                v-spacer
                v-btn(flat='' color='primary' @click="boletas.modalStartDialog = false") Cancel
                v-btn(flat='' color='primary' @click="$refs.dialogStartEECC.save(boletas.startDate)") OK
          v-flex(xs6 sm3 md3 lg3)
            label Hasta
            v-dialog(ref='dialogEndEECC' v-model='boletas.modalEndDialog' :return-value.sync="boletas.endDate" persistent='' lazy='' full-width='' width='290px')
              v-text-field(slot='activator' hide-details v-model="boletas.textFieldEndDate" outline readonly='')
              v-date-picker(v-model="boletas.endDate" locale="es-005" type='month' scrollable='')
                v-spacer
                v-btn(flat='' color='primary' @click="boletas.modalEndDialog = false") Cancel
                v-btn(flat='' color='primary' @click="$refs.dialogEndEECC.save(boletas.endDate)") OK
          v-flex(xs12 sm3 md3 lg3)
          v-flex(xs12 sm3 md3 lg3 class="download-btn")
            v-btn.download-btn-files(type='button' @click="getFilterPagos()") Descargar
      //- .box-prestamos
      .box-comprobante-electronico.cronograma-prestamo(v-if="downCronPagos === true")
        h2
          | Cronogramas de préstamos
          v-menu(v-model='tooltips.showDescargaCronoPrestamo' open-on-hover :close-on-content-click='false' :nudge-top='29' :nudge-right='5' offset-x='')
            template(v-slot:activator='{ on }')
              img(v-on="on" :src="icons.question" width="20px" alt="question" class="question-mark-icon")
            v-card#popover-info
              span
                | Podrás descargar tu(s) cronograma(s)
                br
                | de los préstamos generados
        p(v-for="(pdfLoan, index) in listPdfLoan" :key="index")
          span Descargar cronograma de pago - préstamo {{ pdfLoan.codigoPrestamo }}
          v-btn(type='button' @click="downloadPDFs('cronograma-pago-prestamos', pdfLoan.nombreArchivo, pdfLoan.codigoPrestamo)")
            img(:src="icons.download" :srcset="icons.download" alt="iconDownload")
    //- LOADER PROCESS
    v-dialog(v-model="flags.loader" persistent width="300")
      v-card(color="primary" dark="")
        v-card-text
          | Descargando...
          v-progress-linear.mb-0(indeterminate="" color="white")
    //- DIALOG BOLETAS
    v-dialog(v-model="flags.loaderBoletas" persistent width="500")
      v-card.card-comprobantes
        v-card-text
          img#close-btn-ce(:src="icons.close" alt="downloadCe" @click="flags.loaderBoletas = false")
          h2.omnesMedium
            | Descarga las boletas según
            br
            | las fechas elegidas
          v-layout.wrap__comprobantes(wrap row v-if="listBoletas.length > 0")
            v-flex(md4 lg4 v-if="listBoletas.length == 1")
            v-flex.comprobantes(xs12 sm3 md4 lg4 v-for="(comprobante, index) in listBoletas" :key="comprobante.numero")
              v-layout(row wrap)
                v-flex(md10 lg10)
                  p {{ comprobante.fecProcesoPago.split('-')[0] }} - {{ comprobante.fecProcesoPago.split('-')[1] }}
                v-flex(md2 lg2 @click="getPDFPagos($event, comprobante.idBenPagos)" style="cursor:pointer;")
                  img(:src="icons.downloadCe" alt="downloadCe")
            v-flex(md4 lg4 v-if="listBoletas.length == 1")
    //- MODAL DE ERROR - GENERICO PARA MENSAJES
    v-dialog(class="comprobantes-error", v-model="flags.errorModalComprobantes", width="500")
      v-card.sign-in-modal
        figure.text-xs-center
          img(:src="icons.oops" alt="iconError")
        h2.text-blue.text-xs-center Estimado cliente
        p.mt-3.text-xs-center
          span.d-block.g-text-gray-700(style="font-size:16px") En estos momentos no hay boletas disponibles.
        button.transition-all-3.hover-scale(@click="flags.errorModalComprobantes = false") Entendido
    //- LOADER PROCESS
    v-dialog(v-model="flags.dialogDownload" persistent width="300")
      v-card(color="primary" dark="")
        v-card-text
          | Descargando...
          v-progress-linear.mb-0(indeterminate="" color="white")
</template>

<script>
/* eslint-disable eqeqeq */
import VueMonthlyPicker from 'vue-monthly-picker'
import moment from 'moment'
import { mapActions, mapGetters } from 'vuex'
import Functionalities from '../../interfaces/functionalities'

export default {
  data () {
    return {
      panel: [true],
      loading: false,
      title: '',
      currency: '',
      // Electronic documents
      electronicDocs: null,
      // Loans
      pdfLoan: null,
      listPdfLoan: [],
      // FOR DESKTOP FLAG INFO-PERSONAL POLICY
      policyInfo: true,
      iconDownload: require('./../../assets/icons/boton-descargar-zona-privada.svg'),
      iconPolicyInfo: require('./../../assets/icons-info-policies/resource-30.svg'),
      iconPolicy: require('./../../assets/icons-info-policies/resource-33.svg'),
      boletas: {
        startDate: null,
        endDate: null,
        modalStartDialog: false,
        modalEndDialog: false,
        textFieldStartDate: null,
        textFieldEndDate: null
      },
      icons: {
        visa: require('./../../assets/cambio-cobro/icon-visa.svg'),
        calendar: require('./../../assets/iconsv5/icon-calendar.svg'),
        check: require('./../../assets/iconsv5/icon-check.svg'),
        moneda: require('./../../assets/iconsv5/icon-moneda.svg'),
        question: require('./../../assets/iconsv5/icon-question.svg'),
        download: require('./../../assets/iconsv5/icon-download.svg'),
        shield: require('./../../assets/iconsv5/icon-shield.svg'),
        numeroPoliza: require('./../../assets/iconsv5/icon-numero-placa.svg'),
        mensajeAgente: require('./../../assets/vida-icons/icon-correo.svg'),
        close: require('./../../assets/iconsv5/icon-close-ce.svg'),
        downloadCe: require('./../../assets/iconsv5/icon-download-ce.svg'),
        frecuenciaPago: require('./../../assets/iconsv5/icon-frecuencia-pago.svg'),
        montoPago: require('./../../assets/iconsv5/icon-monto-pago.svg'),
        sumaAsegurada: require('./../../assets/iconsv5/icon-suma-asegurada.svg'),
        pagadoHasta: require('./../../assets/iconsv5/icon-pagado-hasta.svg'),
        alerta: require('./../../assets/iconsv5/icon-alerta.svg')
      },
      tooltips: {
        showRentaPagar: false,
        showDescargaCronoPrestamo: false,
        showDescargaCronogramaRenta: false,
        showConstancia: false
      },
      flags: {
        loader: false,
        loaderBoletas: false,
        errorModalComprobantes: false,
        dialogDownload: false
      },
      additional: {
        fechDiferido: null,
        fechaDoble: null,
        periocidadDoblesSiguiente: null,
        fechaMensual: null
      },
      files: {
        cronogramaRVI: require('./../../assets/downloable/calendario_pagos_RRVV_2026.pdf'),
        cronogramaRPP: require('./../../assets/downloable/calendario_pagos_RPP_2026.pdf')
      },
      amplitude: {
        events: {
          downloadDocuments: 'Descarga de Documentos'
        }
      },
      // FOR DESKTOP FLAG INFO-PERSONAL POLICY
      color: '#01BA3B',
      size: '12px',
      listBoletas: [],
      downPoliza: false,
      downConstjubil: false,
      downCronPagos: false,
      tipoPensionRVI: ['JUBILACIÓN', 'INVALIDEZ PARCIAL', 'INVALIDEZ TOTAL', 'JUBILACIÓN ANTICIPADA']
    }
  },
  props: ['annuity'],
  watch: {
    'boletas.startDate': function () {
      this.boletas.textFieldStartDate = moment(this.boletas.startDate).locale('es').format('MMM-YYYY').split('.').join('')
    },
    'boletas.endDate': function () {
      this.boletas.textFieldEndDate = moment(this.boletas.endDate).locale('es').format('MMM-YYYY').split('.').join('')
    }
  },
  methods: {
    ...mapActions('user', ['getHistoricoPagos', 'getPDFConstanciaJubilacion', 'getPDFPolizaElectronica', 'getPDFHistoricoPago', 'getCronogramaPago', 'getPDFPolizaRentaV2']),
    ...mapActions('event', ['eventLog']),
    downloadPDFs (type, data, codigo) {
      const self = this
      let currentDate = new Date().getFullYear()
      let eventGTM = ''
      let labelAction = ''
      let labelGTM = ''
      switch (type) {
      case 'constancia-jubila':
        if (!Functionalities.isAvailable(Functionalities.rentas.CONSTANCIA_JUBILACION, self.functionsRules, self)) {
          return
        }
        eventGTM = 'DCJ'
        labelAction = 'ConstanciaJubilacion'
        labelGTM = 'Descarga de Constancia de Jubilación'
        // TRACK EVENT - AMPLITUDE
        this.$amplitude.getInstance()
          .logEvent(
            this.amplitude.events.downloadDocuments,
            {
              'Tipo Documento': 'Constancia de Jubilación',
              'Producto Consultado': 'Rentas'
            }
          )
        break
      case 'cronograma-pago-prestamos':
        if (!Functionalities.isAvailable(Functionalities.rentas.CRONOGRAMA_PRESTAMO, self.functionsRules, self)) {
          return
        }
        eventGTM = 'DCPP'
        labelAction = 'CronogramaPagoPrestamo'
        labelGTM = 'Descarga de Pago Prestamo'
        // TRACK EVENT - AMPLITUDE
        this.$amplitude.getInstance()
          .logEvent(
            this.amplitude.events.downloadDocuments,
            {
              'Tipo Documento': 'Cronograma de Pago Prestamo',
              'Producto Consultado': 'Rentas'
            }
          )
        break
      case 'cronograma-rvi':
        eventGTM = 'Descargas Cronograma RV'
        labelAction = 'CronogramaPagoRentaVitaliciaJubilacion'
        labelGTM = 'Descarga de Cronograma Pago Jubilacion Rentas Vitalicias'
        // TRACK EVENT - AMPLITUDE
        this.$amplitude.getInstance()
          .logEvent(
            this.amplitude.events.downloadDocuments,
            {
              'Tipo Documento': 'Cronograma de Pago Jubilación Rentas Vitalicias',
              'Producto Consultado': 'Rentas'
            }
          )
        break
      case 'cronograma-rpp':
        eventGTM = 'Descargas Cronograma RP'
        labelAction = 'CronogramaPagoRentaParticularPlus'
        labelGTM = 'Descarga de Cronograma Pago Renta Particular Plus'
        // TRACK EVENT - AMPLITUDE
        this.$amplitude.getInstance()
          .logEvent(
            this.amplitude.events.downloadDocuments,
            {
              'Tipo Documento': 'Cronograma de Pago Renta Particular Plus',
              'Producto Consultado': 'Rentas'
            }
          )
        break
      default:
        if (!Functionalities.isAvailable(Functionalities.rentas.DESCARGA_POLIZA, self.functionsRules, self)) {
          return
        }
        eventGTM = 'DPE'
        labelAction = 'PolizaElectronica'
        labelGTM = 'Descarga de Póliza Electrónica'
        // TRACK EVENT - AMPLITUDE
        this.$amplitude.getInstance()
          .logEvent(
            this.amplitude.events.downloadDocuments,
            {
              'Tipo Documento': 'Póliza Rentas'
              // 'Producto Consultado': 'Rentas'
            }
          )
        break
      }
      this.flags.dialogDownload = true
      this.$gtm.trackEvent({
        event: eventGTM,
        category: 'Zona Privada',
        action: labelAction,
        label: labelGTM
      })
      const callbackNPS = () => {
        setTimeout(() => {
          self.$root.$emit('showNps', {
            nombre: 'NPS - Inicio de Encuesta',
            funcionalidad: labelGTM,
            metadata: {
              numeroPoliza: self.annuity.numeroPoliza,
              productoConsultado: self.annuity.ramo,
              subproductoConsultado: self.annuity.codigoProducto
            }
          })
        }, 3000)
      }
      if (type === 'cronograma-rvi' || type === 'cronograma-rpp') {
        const file = type === 'cronograma-rvi' ? 'Calendario_Pagos_RRVV_' + currentDate + '.pdf' : 'Calendario_Pagos_RPP_' + currentDate + '.pdf'
        const url = type === 'cronograma-rvi' ? this.files.cronogramaRVI : this.files.cronogramaRPP
        const eventData = {
          categoria: 'Documentos',
          nombre: 'Cronograma de pagos',
          datos: {
            numeroPoliza: self.annuity.numeroPoliza,
            producto: self.annuity.codigoProducto,
            dispositivo: 'desktop',
            archivo: file,
            url
          }
        }
        this.flags.dialogDownload = false
        let link = document.createElement('a')
        link.href = url
        link.download = file
        link.target = '_blank'
        link.click()
        self.eventLog(eventData)
        callbackNPS()
      } else if (type !== 'cronograma-pago-prestamos') {
        if (type === 'constancia-jubila') {
          // PARAMS only for constancia-jubilacion
          // SOLO ADMITIMOS DNIs y CEs
          let paramsJubilacion = {
            'cartera': 'RVI',
            'num_poliza': this.annuity.numeroPoliza,
            'cod_tipo_identificacion': this.basicInfo.numeroDocumento.length === 8 ? 'D' : 'CE',
            'num_identificacion': this.basicInfo.numeroDocumento,
            'usuario': 'WEB'
          }
          const eventData = {
            categoria: 'Documentos',
            nombre: 'Constancia de Jubilación - Front',
            datos: {
              numeroPoliza: this.annuity.numeroPoliza,
              producto: 'RVI',
              dispositivo: 'desktop',
              usuario: 'WEB'
            }
          }
          this.getPDFConstanciaJubilacion(paramsJubilacion)
            .then((res) => {
              this.flags.dialogDownload = false
              eventData.datos.response = res.data
              eventData.datos.statusCode = res.status
              self.eventLog(eventData)
              callbackNPS()
            })
            .catch((err) => {
              eventData.datos.response = err.response.data
              eventData.datos.statusCode = err.response.status
              this.flags.dialogDownload = false
              self.eventLog(eventData)
              callbackNPS()
            })
        } else if (this.annuity.codigoProducto === 'IFP' || this.annuity.codigoProducto === 'RPP' || this.annuity.codigoProducto === 'RVI' || this.annuity.codigoProducto === 'RRVV') {
          this.getPDFPolizaRentaV2({ tipo: this.annuity.codigoProducto, numeroPoliza: this.annuity.numeroPoliza })
            .then(res => {
              this.flags.dialogDownload = false
              // HTTP RESPONSE: NO CONTENT
              if (res.status === 204) {
                this.$swal({
                  title: 'Comunicado',
                  text: 'Esta póliza aún no cuenta con el archivo generado. Por favor, comunicate al Servicio de Atención al Cliente para que puedan generarlo y enviartelo a tu correo electrónico.',
                  type: 'info',
                  confirmButtonText: 'Entendido'
                })
              }
              callbackNPS()
            })
            .catch(() => {
              this.flags.dialogDownload = false
            })
        }
      } else {
        // SI PIDE CRONOGRAMA DE PAGO DE RENTAS
        const url = `${process.env.API_URL_V2}lines/annuities/downloads/` + data
        self.flags.dialogDownload = false
        let link = document.createElement('a')
        link.href = url
        link.download = codigo
        link.target = '_blank'
        const eventData = {
          categoria: 'Documentos',
          nombre: 'Descarga de Pago Prestamo',
          datos: {
            numeroPoliza: self.annuity.numeroPoliza,
            producto: self.annuity.codigoProducto,
            dispositivo: 'desktop',
            codigoPrestamo: codigo,
            url
          }
        }
        self.eventLog(eventData)
        link.click()
        callbackNPS()
      }
    },
    getPDFPagos (evt, idBenPagos) {
      const self = this
      evt.preventDefault()
      this.flags.dialogDownload = true
      // TRACK EVENT - GA
      this.$gtm.trackEvent({
        event: 'DBP',
        category: 'Zona Privada',
        action: 'BoletaPension',
        label: 'Descarga de Boletas de Pensión'
      })
      // TRACK EVENT - AMPLITUDE
      this.$amplitude.getInstance()
        .logEvent(
          this.amplitude.events.downloadDocuments,
          {
            'Tipo Documento': 'Boletas de Pensión',
            'Producto Consultado': 'Rentas',
            'Año consultado': this.boletas.endDate.split('-')[0],
            'Mes consultado': this.boletas.endDate.split('-')[1]
          }
        )
      let hash = { codigoPago: idBenPagos, tipoProducto: this.annuity.codigoProducto, numeroPoliza: this.annuity.numeroPoliza }
      this.getPDFHistoricoPago(hash)
        .then(() => {
          this.flags.dialogDownload = false
        })
        .catch(() => {
          this.flags.dialogDownload = false
        })

      setTimeout(() => {
        self.$root.$emit('showNps', {
          nombre: 'NPS - Inicio de Encuesta',
          funcionalidad: 'Descarga de Boletas de Pensión',
          metadata: {
            numeroPoliza: self.annuity.numeroPoliza,
            productoConsultado: self.annuity.ramo,
            subproductoConsultado: self.annuity.codigoProducto
          }
        })
      }, 3000)
    },
    getFilterPagos () {
      const self = this
      if (!Functionalities.isAvailable(Functionalities.rentas.BOLETAS, self.functionsRules, self)) {
        return
      }
      if (this.historyPayments != null) {
        this.listBoletas = []
        for (let index = 0; index < this.historyPayments.length; index++) {
          let pago = this.historyPayments[index]
          let pagoMoment = moment(pago.fecProcesoPago)
          let startMoment = moment(this.boletas.startDate).startOf('month')
          let endMoment = moment(this.boletas.endDate).endOf('month')
          if (pagoMoment.isSameOrBefore(endMoment) && pagoMoment.isSameOrAfter(startMoment)) {
            this.listBoletas.push(pago)
          }
        }
        if (this.listBoletas.length > 0) {
          this.flags.loaderBoletas = true
        } else {
          this.$swal({
            title: 'Aviso',
            text: 'No hay boletas disponibles en las fechas elegidas. Por favor, escoger otras fechas.',
            type: 'info',
            confirmButtonText: 'Entendido'
          })
        }
      }
    },
    /*
    sendMailTo () {
      let mail = document.createElement('a')
      mail.href = 'mailto:servicios@interseguro.com.pe' // + this.annuity.emailAgente
      mail.click()
    },
    */
    closeModalAnnuity () {
      // HIDE SUB-NAV
      this.$root.$emit('hideAnnuity', {})
    },
    verifySectionDownload () {
      // this.downPoliza = (this.annuity.codigoProducto !== 'RPP' && this.annuity.codigoProducto !== 'IFP')
      this.downCronPagos = (this.listPdfLoan.length > 0 && (this.annuity.codigoProducto === 'RPP' || this.annuity.codigoProducto === 'IFP'))
      // console.log('downCronPagos: ', this.downCronPagos, this.listPdfLoan.length)
    }
  },
  computed: {
    ...mapGetters('user', ['historyPayments', 'userInfo', 'basicInfo', 'functionsRules'])
  },
  mounted () {
    this.listPdfLoan = []
    let numeroPoliza = this.annuity.numeroPoliza
    this.title = 'Hola ' + this.userInfo.nombreUsuario
    this.annuity.asegurado = this.annuity.asegurado !== '' ? this.annuity.asegurado : (this.userInfo.nombreUsuario + ' ' + this.userInfo.apellidoPaternoUsuario + ' ' + this.userInfo.apellidoMaternoUsuario)
    this.currency = (this.annuity.primaProgramadaMoneda.includes('S/') || this.annuity.primaProgramadaMoneda.includes('NUEVO SOL') || this.annuity.primaProgramadaMoneda.includes('SOLES')) ? 'S/.' : '$'
    let hash = { numeroPoliza: numeroPoliza, codigoUsuario: this.userInfo.codigoUsuario }
    this.downConstjubil = (this.annuity.codigoProducto !== 'RPP' && this.annuity.codigoProducto !== 'IFP')
    // Obtener los pagos de las boletas por anticipado
    this.getHistoricoPagos(hash)
      .then((res) => {
        if (this.historyPayments !== null) {
          // console.log('PAGOS: ', this.historyPayments)
        }
      })
      .catch(() => {
        this.$swal({
          imageUrl: require('@/assets/characters/sorprendido.svg'),
          title: '¡Lo sentimos!',
          text: 'Se generó una interrupción en la consulta de tus boletas de pago. Por favor, vuelve a intentarlo en unos minutos.',
          confirmButtonText: 'Entendido'
        })
      })
    // TMP: Fechas para boletas
    this.boletas.startDate = moment(new Date(), 'DD-MM-YYYY').subtract(1, 'months').format('YYYY-MM')
    this.boletas.endDate = moment(new Date(), 'DD-MM-YYYY').format('YYYY-MM')
    // ONLY FOR RPP/IFP
    if (this.annuity.codigoProducto === 'RPP' || this.annuity.codigoProducto === 'IFP') {
      // MONTO
      this.annuity.montoDevolucion = parseFloat(this.annuity.montoDevolucion)
      // FECHA
      let arrFecha = this.annuity.fechaVigencia.split('/')
      let fechaVigencia = moment(arrFecha[2] + '-' + arrFecha[1] + '-' + arrFecha[0])
      // MESES - FROM STR TO INT
      this.annuity.ingresosDobles = parseInt(this.annuity.ingresosDobles)
      this.annuity.mesesTemporalidad = parseInt(this.annuity.mesesTemporalidad)
      this.annuity.periodoDiferido = parseInt(this.annuity.periodoDiferido)
      this.annuity.periodoGarantizado = parseInt(this.annuity.periodoGarantizado)
      // CALCULOS
      let periocidadDiferido = fechaVigencia.clone().add(this.annuity.periodoDiferido, 'months')
      let periocidadDobles = periocidadDiferido.clone().add(this.annuity.ingresosDobles, 'months')
      let periocidadMensual = periocidadDobles.clone().add(this.annuity.mesesTemporalidad - this.annuity.periodoDiferido - this.annuity.ingresosDobles, 'months')
      // SET DATA
      this.additional.periocidadDiferido = periocidadDiferido.lang('es').format('MMMM YYYY').charAt(0).toUpperCase() + periocidadDiferido.lang('es').format('MMMM YYYY').slice(1)
      this.additional.periocidadDobles = periocidadDobles.lang('es').format('MMMM YYYY').charAt(0).toUpperCase() + periocidadDobles.lang('es').format('MMMM YYYY').slice(1)
      if (this.annuity.ingresosDobles > 0) {
        let periocidadDoblesAux = periocidadDobles.clone().add(1, 'months')
        this.additional.periocidadDoblesSiguiente = periocidadDoblesAux.lang('es').format('MMMM YYYY').charAt(0).toUpperCase() + periocidadDoblesAux.lang('es').format('MMMM YYYY').slice(1)
      }
      if (this.annuity.mesesTemporalidad === 0) {
        this.additional.periocidadMensual = 'Vitalicio'
      } else {
        // restar 1 dia
        periocidadMensual = periocidadMensual.subtract(1, 'days')
        this.additional.periocidadMensual = periocidadMensual.lang('es').format('MMMM YYYY').charAt(0).toUpperCase() + periocidadMensual.lang('es').format('MMMM YYYY').slice(1)
      }
      // GET PDF CRONOGRAMA
      let prestamos = this.annuity.prestamos
      for (let index = 0; index < prestamos.length; index++) {
        this.getCronogramaPago({ numeroPoliza: prestamos[index].codigoPrestamo })
          .then(res => {
            this.listPdfLoan.push({ nombreArchivo: res.data.nombreArchivo, codigoPrestamo: prestamos[index].codigoPrestamo })
            this.verifySectionDownload()
            // this.pdfLoan = res.data.nombreArchivo
          })
          .catch(() => {
            this.verifySectionDownload()
          })
      }
    }
  },
  components: {
    VueMonthlyPicker
  }
}
</script>

<style>
/** GLOBAL INFO */
.mediumLarge .box-global-info {
  border: #D8D8D8 1px solid;
  padding: 15px 24px 0px 24px;
}
.mediumLarge .box-global-info ul { padding: 0; }
.mediumLarge .box-global-info ul ol {
  overflow: hidden;
  padding-left: 0;
  border-bottom: 1px solid #D8D8D8;
  padding: 12px 0;
}
.mediumLarge .box-global-info ul ol:last-child { border-bottom: 0; }
.mediumLarge .box-global-info ul ol p {
  margin-bottom: 0;
  display: flex;
  align-items: center;
}
.mediumLarge .box-global-info ul ol p:first-child { float: left; }
.mediumLarge .box-global-info ul ol p:first-child + p { float: right; }
.mediumLarge .box-global-info ul ol p img {
  margin-right: 9px;
  width: 20px;
}
.mediumLarge .box-global-info ul ol p.poliza-download img {
  margin-right: 0;
  margin-left: 7px;
  width: 24px;
  cursor: pointer;
}
/** BENEFICIARIOS */
.mediumLarge .box-beneficiarios {
  border: #D8D8D8 1px solid;
  padding: 15px 24px 0 24px;
  margin: 2em 0;
}
.mediumLarge .box-beneficiarios .layout { margin-bottom: 0 !important; }
.mediumLarge .box-beneficiarios .layout:last-child { margin-bottom: 0.4em !important; }
.mediumLarge .box-beneficiarios .layout .name-beneficiario p { text-transform: lowercase !important; }
.mediumLarge .box-beneficiarios .layout .name-beneficiario p::first-letter { text-transform: uppercase !important; }
.mediumLarge .box-beneficiarios .name-beneficiario p { display: flex; }
.mediumLarge .box-beneficiarios .name-beneficiario img {
  width: 15px;
  margin-right: 7px;
}
/** AGENTE */
.mediumLarge .box-agente {
  border: #D8D8D8 1px solid;
  padding: 15px 24px;
  margin-top: 2em; /** ESTA LINEA ES TEMPORAL HASTA ACTIVAR BENEFICIARIOS DENUEVO */
}
.mediumLarge .box-agente .layout .flex {
  /* border: #D8D8D8 1px solid; */
  padding: 3px !important;
}
.mediumLarge .box-agente .layout .flex p {
  margin-bottom: 0;
  display: flex;
  font-weight: normal;
  font-family: 'Omnes Medium';
  align-items: center;
}
.mediumLarge .box-agente .layout .flex p img {
  width: 19px;
  margin-right: 12px;
}
/** NUMERO DE POLIZA */
.mediumLarge .box-numero-poliza .layout .flex p {
  border: #D8D8D8 1px solid;
  padding: 0 24px;
  font-family: 'Omnes Medium';
  line-height: 46px;
  height: 46px;
}
/** MEDIO DE PAGO */
.mediumLarge .box-medio-pago h2 {
  color: #0855C4;
  font-weight: normal;
  font-size: 18px;
  margin-bottom: 0.5em;
}
.mediumLarge .box-medio-pago .layout .flex p {
  border: 1px solid #D8D8D8;
  padding: 0 24px;
  font-family: 'Omnes Medium';
  display: flex;
  line-height: 46px;
  height: 46px;
}
/** ESTADO DE CUENTA */
/** COMPROBANTE ELECTRONICO */
.mediumLarge .box-comprobante-electronico .layout .flex .v-input.date-selector .v-input__control .v-input__slot {
  min-height: 46px;
  border: 1px solid #D8D8D8;
}
.mediumLarge .box-comprobante-electronico .layout .flex .v-input.date-selector .v-input__control .v-input__slot .v-select__slot label { top: 14px; }
.mediumLarge .box-comprobante-electronico .layout .flex .v-input.date-selector .v-input__control .v-input__slot .v-select__slot .v-select__selections { padding-top: 3px; }
.mediumLarge .box-comprobante-electronico .layout .flex .v-input.date-selector .v-input__control .v-input__slot .v-select__slot .v-select__selections input::placeholder { color: rgba(0,0,0,0.87); }
.mediumLarge .box-comprobante-electronico .layout .flex .v-input.date-selector .v-input__control .v-input__slot .v-select__slot .v-select__selections .v-select__selection { margin: 0; }
.mediumLarge .box-comprobante-electronico .layout .flex .v-input.date-selector .v-input__control .v-input__slot .v-select__slot .v-input__append-inner { margin-top: 12px; }
.mediumLarge .box-comprobante-electronico .layout .flex .v-input.date-selector .v-input__control .v-input__slot .v-select__slot .v-input__append-inner .v-input__icon i {
  color: #0855C4;
  font-size: 30px;
}
/** TOOLTIPS */
#popover-info {
  background-color: var(--text-color);
  padding: 8px 12px 10px 12px;
}
#popover-info span,
#popover-info p {
  color: #FFF;
  font-size: 14px;
}
/** GLOBAL STYLES */
.mediumLarge .flex .box-global-info h2 {
  margin-bottom: 0.5em;
}
.mediumLarge .box-global-info h2,
.mediumLarge .box-beneficiarios h2,
.mediumLarge .box-comprobante-electronico h2,
.mediumLarge .box-estado-cuenta h2,
.mediumLarge .box-numero-poliza h2,
.mediumLarge .box-agente h2,
.mediumLarge .box-beneficiarios h2 {
  display: flex;
  color: #0855C4;
  font-size: 18px;
  font-weight: normal;
  margin-bottom: 0.7em;
}
.mediumLarge .box-agente h2 {
  margin-bottom: 0.3em;
}
.mediumLarge .box-beneficiarios h2 img.question-mark-icon,
.mediumLarge .box-comprobante-electronico h2 img.question-mark-icon,
.mediumLarge .box-estado-cuenta h2 img.question-mark-icon,
.mediumLarge .box-numero-poliza h2 img.question-mark-icon,
.mediumLarge .box-agente h2 img.question-mark-icon,
.mediumLarge .box-beneficiarios h2 img.question-mark-icon,
.mediumLarge .box-global-info ul ol p:first-child img.question-mark-icon {
  margin-left: 8px;
}
.mediumLarge .box-medio-pago,
.mediumLarge .box-comprobante-electronico,
.mediumLarge .box-estado-cuenta {
  border: #D8D8D8 1px solid;
  padding: 15px 24px 20px 24px;
  margin-bottom: 1.5em;
}
.mediumLarge .box-comprobante-electronico .layout,
.mediumLarge .box-estado-cuenta .layout {
  margin-top: 10px;
}
.mediumLarge .box-comprobante-electronico .flex p,
.mediumLarge .box-estado-cuenta .flex p {
  margin-bottom: 0;
}
.mediumLarge .box-comprobante-electronico .flex .v-dialog__container .v-dialog__activator .v-input .v-input__control .v-input__slot .v-input__prepend-inner,
.mediumLarge .box-estado-cuenta .flex .v-dialog__container .v-dialog__activator .v-input .v-input__control .v-input__slot  .v-input__prepend-inner {
  padding-right: 8px;
  margin-top: 2px;
  align-self: center;
}
.mediumLarge .box-comprobante-electronico .flex .v-dialog__container .v-dialog__activator .v-input .v-input__control .v-input__slot,
.mediumLarge .box-estado-cuenta .flex .v-dialog__container .v-dialog__activator .v-input .v-input__control .v-input__slot {
  min-height: 46px;
  border: 1px solid #D8D8D8;
}
.mediumLarge .box-comprobante-electronico .flex .v-dialog__container .v-dialog__activator .v-input .v-input__control .v-input__slot .v-text-field__slot input,
.mediumLarge .box-estado-cuenta .flex .v-dialog__container .v-dialog__activator .v-input .v-input__control .v-input__slot .v-text-field__slot input {
  margin-top: 6px;
  text-align: center;
}
.mediumLarge .box-numero-poliza .download-btn,
.mediumLarge .box-medio-pago .edit-btn,
.mediumLarge .box-estado-cuenta .download-btn {
  text-align: right;
  align-self: flex-end;
  margin-bottom: 2px;
}
.mediumLarge .box-comprobante-electronico .download-btn  { text-align: right; }
.mediumLarge .box-estado-cuenta .download-btn button.download-btn-files,
.mediumLarge .box-comprobante-electronico .download-btn button.download-btn-files {
  min-height: 45px;
  height: 45px;
}
/** NUEVOS COMPONENTES */
.mediumLarge .box-comprobante-electronico.cronograma-prestamo p,
.mediumLarge .box-agente.constancia p,
.mediumLarge .box-agente.cronograma-rentas p {
  overflow: hidden;
  display: flex;
  justify-content: space-between;
}
.mediumLarge .box-comprobante-electronico.cronograma-prestamo p span,
.mediumLarge .box-agente.constancia p span,
.mediumLarge .box-agente.cronograma-rentas p span {
  float: left;
  padding-top: 7px;
}
.mediumLarge .box-comprobante-electronico.cronograma-prestamo button .v-btn__content img,
.mediumLarge .box-agente.constancia button .v-btn__content img,
.mediumLarge .box-agente.cronograma-rentas button .v-btn__content img {
  width: 25px;
}
.mediumLarge .box-comprobante-electronico.cronograma-prestamo button,
.mediumLarge .box-agente.constancia button,
.mediumLarge .box-agente.cronograma-rentas button {
  background-color: transparent !important;
  box-shadow: none;
  padding: 0;
  margin: 0;
  float: right;
  min-width: 30px;
  width: 30px;
  align-self: center;
}
.mediumLarge .box-comprobante-electronico.cronograma-prestamo button:focus:before,
.mediumLarge .box-agente.constancia button:focus:before,
.mediumLarge .box-agente.cronograma-rentas button:focus:before {
  background-color: transparent !important;
  box-shadow: none !important;
}
/** MODAL DE COMPROBANTES */
#close-btn-ce {
  cursor: pointer;
  float: right;
}
.card-comprobantes h2 {
  text-align: center;
  clear: both;
  font-size: 21px;
  line-height: 1.2;
  width: 69%;
  margin: 3em auto 2em auto;
}
.card-comprobantes .v-card__text .layout.wrap__comprobantes { margin-bottom: 2em; }
.card-comprobantes .flex.comprobantes .layout {
  border: 2px solid #D8D8D8;
  border-radius: 4px;
}
.card-comprobantes .flex.comprobantes .layout .flex {
  text-align: center;
}
.card-comprobantes .flex.comprobantes .layout .flex p {
  margin-bottom: 0;
  margin: 8px 0;
  border-right: 1px solid #D8D8D8;
  padding: 2px 0;
}
.card-comprobantes .flex.comprobantes .layout .flex img {
  border-bottom: 2px solid var(--fuchsia-color);
  padding-bottom: 3px;
  padding-top: 9px;
  width: 12px;
}
.card-comprobantes .flex.comprobantes .layout .flex:first-child + .flex {
  align-self: center;
}
p.message-date-alert-ce {
  font-size: 15px;
  text-align: center;
}
.v-btn.download-btn-files.btn-date-alert-ce {
  width: 100%;
  padding: 19px 0 17px 0;
  height: 55px;
  margin-bottom: 1.5em;
}
.v-btn.download-btn-files.btn-date-alert-ce .v-btn__content {
  font-size: 18px;
}
</style>



// WEBPACK FOOTER //
// src/components/rentas/FormDesktopRentas.vue